module.exports = __webpack_public_path__ + "img/my_photo1@2x.fca3fa57.png";